import React from "react";

/**
 * Section wrapper used for grouped dashboard blocks with a title row.
 */
export default function Section({ title, subtitle, action, children, className = "" }) {
    return (
        <section className={className}>
            {(title || action) && (
                <div className="mb-4 flex items-center justify-between gap-4">
                    <div className="min-w-0">
                        {title && (
                            <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">{title}</h2>
                        )}
                        {subtitle && (
                            <p className="mt-0.5 text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>
                        )}
                    </div>
                    {action && <div className="flex-shrink-0">{action}</div>}
                </div>
            )}
            {children}
        </section>
    );
}
